"use strict";

const state = {
  // fullName: { firstName: "omar", lastName: "mhiri" },
  basket:{}
};

const getters = {
  getbasket: (state) => {
    return state.basket;
  },
};

const mutations = {
  setbasket: (state, payload) => {
    state.basket = payload;
  },
};

const actions = {
  setbasket: ({ commit, state, dispatch }, payload) => {
    commit("setbasket", payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
